import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

function Footer() {
  return (
    <ArgonBox component="footer" py={4}>
      <ArgonBox display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <ArgonTypography variant="body2" color="secondary" sx={{ mb: 1 }}>
          &copy; {new Date().getFullYear()} PRM Core
        </ArgonTypography>
        <ArgonBox display="flex" gap={3}>
          <ArgonTypography
            component="a"
            href="https://prmcore.com/privacy.html"
            variant="caption"
            color="secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </ArgonTypography>
          <ArgonTypography
            component="a"
            href="mailto:contact@prmcore.com"
            variant="caption"
            color="secondary"
          >
            Contact
          </ArgonTypography>
        </ArgonBox>
      </ArgonBox>
    </ArgonBox>
  );
}

export default Footer;
